import React from 'react';


const HiddenFileInput = React.forwardRef(function HiddenFileInput({apiFileEndpoint, apiRequestParams, inputAccept = "*", onUpload = () => {}, onSelectFile = () => {}, async = false}, parentRef)
{
    const fileInput = React.useRef();
    const [files, setFiles] = React.useState([]);

    const uploadSync = React.useCallback(async (file) =>
    {
        let form = new FormData();
        form.append('file', file);
        let result = await apiFileEndpoint.post(...apiRequestParams, form);
        if(result.ok)
        {
            let json = {};
            try
            {
                json = await result.json();
            }
            catch {}
            onUpload(json);
        }
        else
        {
            console.error(result);
        }
    }, [apiFileEndpoint, apiRequestParams, onUpload]);

    
    const uploadAsync = React.useCallback(async () => {
        for(let i=0;i<files.length;i++)
        {
            await uploadSync(files[i]);
        }
        setFiles([]);
    }, [files, uploadSync]);


    React.useImperativeHandle(parentRef, () => ({
        click: () => fileInput.current.click(), 
        native: fileInput.current,
        files: files,
        uploadASync: uploadAsync
    }));

    

    async function inputOnChangeHandler()
    {
        if(!async)
        {
            await uploadSync(fileInput.current.files[0]);
        }
        else
        {
            setFiles([...files, fileInput.current.files[0]]);
            onSelectFile(fileInput.current.files[0]);
        }

        if(fileInput.current) fileInput.current.value = '';
    }


    return <div style={{display: 'none'}}>
        <input name="file" hidden type="file" onChange={inputOnChangeHandler} ref={fileInput} accept={inputAccept}/>
    </div>
});

export default HiddenFileInput;